"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var i18nHelper_1 = __importDefault(require("../helpers/i18nHelper"));
var object_helpers_1 = require("../../../helpers/object.helpers");
var I18NProvider = /** @class */ (function (_super) {
    __extends(I18NProvider, _super);
    function I18NProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (language, catalog) {
            if (!_this.props.onChange) {
                return;
            }
            _this.props.onChange(language, catalog);
        };
        _this.state = { i18ninit: false };
        return _this;
    }
    I18NProvider.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, backendOpts = _a.backendOpts, lang = _a.lang, catalog = _a.catalog, reactOpts = _a.reactOpts, resources = _a.resources;
        i18nHelper_1.default
            .init(lang, catalog, backendOpts, reactOpts, resources)
            .then(function () {
            _this.onChange(lang, catalog);
            _this.setState({ i18ninit: true });
        })
            .catch(function (err) {
            // If backend returns error, report it to console and initiate loading of child components.
            // If we don't do this, screen will stay in loading mode.
            console.error(err);
            _this.setState({ i18ninit: true });
        });
    };
    I18NProvider.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!this.state.i18ninit) {
            return;
        }
        if (this.props.resources) {
            if (!object_helpers_1.objectsAreEqual(this.props.resources, prevProps.resources || {})) {
                i18nHelper_1.default
                    .setNewResources(this.props.lang, this.props.catalog, this.props.resources[this.props.lang][this.props.catalog])
                    .then(function () { return _this.onChange(_this.props.lang, _this.props.catalog); });
            }
            return;
        }
        if (this.props.lang === prevProps.lang && this.props.catalog === prevProps.catalog) {
            return;
        }
        i18nHelper_1.default
            .reload(this.props.lang, this.props.catalog)
            .then(function () { return _this.onChange(_this.props.lang, _this.props.catalog); });
    };
    I18NProvider.prototype.render = function () {
        var appRender = this.state.i18ninit && this.props.externalsLoaded;
        return react_1.default.createElement(react_1.Fragment, null, appRender ? this.props.children : this.getLoader());
    };
    I18NProvider.prototype.getLoader = function () {
        if (this.props.loader) {
            return this.props.loader;
        }
        var style = {
            padding: '10px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            fontWeight: 'bold',
            fontSize: '20px',
            textAlign: 'center',
        };
        return react_1.default.createElement("div", { style: style }, "Loading!");
    };
    I18NProvider.displayName = 'I18NProvider';
    I18NProvider.defaultProps = {
        externalsLoaded: true,
    };
    return I18NProvider;
}(react_1.default.PureComponent));
exports.default = I18NProvider;
